<template>
  <div
    class="table-wrap table-wrap--plans-info"
    v-if="showPlanDesignsMiniTable"
  >
    <div class="table">
      <div class="table-row table-row--low-height">
        <div class="table-unit table-desc-unit">Age Requirement</div>
        <div class="table-unit" v-for="design in designs">
          <span v-html="ageRequirement(design)"></span>
        </div>
      </div>
      <div class="table-row table-row--low-height">
        <div class="table-unit table-desc-unit">Service Requirement</div>
        <div class="table-unit" v-for="design in designs">
          <span v-html="serviceRequirement(design)"></span>
        </div>
      </div>
      <div class="table-row table-row--low-height">
        <div class="table-unit table-desc-unit">Auto Enrollment</div>
        <div class="table-unit" v-for="design in designs">
          <span v-html="autoEnrollment(design)"></span>
        </div>
      </div>
      <div class="table-row table-row--low-height">
        <div class="table-unit table-desc-unit">Auto Escalation</div>
        <div class="table-unit" v-for="design in designs">
          <span v-html="autoEscalation(design)"></span>
        </div>
      </div>
      <div class="table-row table-row--low-height">
        <div class="table-unit table-desc-unit">Employer Match</div>
        <div class="table-unit" v-for="design in designs">
          <span v-html="employerMatch(design)"></span>
          <roe-tooltip
            v-if="employerMatchTooltip(design)"
            class="design-table"
            :text="employerMatchTooltip(design)"
          ></roe-tooltip>
        </div>
      </div>
      <div class="table-row table-row--low-height">
        <div class="table-unit table-desc-unit">Basic Contribution</div>
        <div class="table-unit" v-for="design in designs">
          <span v-html="employerOther(design)"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RoeTooltip from "@/components/_shared/Tooltip";
export default {
  name: "RoePlanDesignsMiniTable",
  components: { RoeTooltip },
  computed: {
    ...mapGetters([
      "showPlanDesignsMiniTable",
      "designs",
      "ageRequirement",
      "serviceRequirement",
      "autoEnrollment",
      "autoEscalation",
      "employerMatch",
      "employerMatchTooltip",
      "employerOther"
    ])
  }
};
</script>
